import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Features } from './components/Features';
import { CtaBanner } from './components/CtaBanner';
import { Footer } from './components/Footer';
import { QuotePage } from './pages/QuotePage';
function HomePage() {
  return <>
      <Hero data-id="element-0" />
      <Services data-id="element-1" />
      <Features data-id="element-2" />
      <CtaBanner data-id="element-3" />
    </>;
}
export function App() {
  return <div className="min-h-screen flex flex-col" data-id="element-4">
      <Navbar data-id="element-5" />
      <main className="flex-grow" data-id="element-6">
        <Routes data-id="element-7">
          <Route path="/" element={<HomePage data-id="element-9" />} data-id="element-8" />
          <Route path="/quote" element={<QuotePage data-id="element-11" />} data-id="element-10" />
        </Routes>
      </main>
      <Footer data-id="element-12" />
    </div>;
}